import { WorkflowView } from "./WorkflowView";
import { BookJobCommunicationsWorkflowFactory } from "../../factories/BookJobCommunicationsWorkflowFactory";
import { useDefinedParams } from "../../hooks/useDefinedParams";
import { useStoreSite } from "../../hooks/useStoreSite";
import { getSiteErrorType, getSiteSuccessType } from "../../../../APIDocs/apiTypes";
import { Logger } from "../../Logger";
import { RestTypes, useJbpQuery } from "../../hooks/useJbpQuery";

export const BookJobCommunications = () => {
    const [mpan, serviceLine] = useDefinedParams(["mpan", "serviceLine"]);
    const storeSiteData = useStoreSite();

    const onSiteData = (data: getSiteSuccessType) => {
        storeSiteData.storeSite(mpan, serviceLine, data);
    }

    const onSiteDataError = (err: getSiteErrorType) => {
        Logger.Log(`Data found to not exist -> ${err.msg}`)
    }

    const { refetch } = useJbpQuery<getSiteSuccessType, getSiteErrorType>(RestTypes.Get, undefined, ['site-bookJobCommunications'], `jbp/${mpan}/site`, true, serviceLine, onSiteData, onSiteDataError)

    if(storeSiteData.dataStored == false) {
        refetch();
        return <span></span>
    }

    return <WorkflowView mpan={mpan} serviceLine={serviceLine} title="Complete Booking for" workflowFactory={new BookJobCommunicationsWorkflowFactory(mpan, serviceLine)} />
}
